import { useState } from "react";
import PopUp from "./popup";

import artistData from "../views/placeholder/artistData";


const getArtistName = (id:number) => {


    return artistData.filter (
        (artistData) => artistData.id === id
    )

}


const PortfolioBlock  = (props:any) => {

    const [buttonPopUp, setButtonPopUp] = useState(false);

    return (
        <div className="portfolio__block">
            <div className="portfolio_img">
                <img src={props.data.image} onClick={()=>setButtonPopUp(true)} alt="img"/>
            </div>

        
        <PopUp trigger={buttonPopUp} setTrigger={setButtonPopUp}> 
        
            <div className="portfolio_popup">

            <img src={props.data.image} onClick={()=>setButtonPopUp(true)} alt="img"/>
            <div className="portfolio_popup_inner">
                <p className="text_nofont portpolio_label">Artist</p>
                <h3>{getArtistName(props.data.artistId)[0].name}</h3>
                <p className="text_nofont portpolio_label">Style</p>
                <h3>{props.data.category}</h3>
                <p className="text_nofont portpolio_label">Description</p>
                <div>
                    <p className="text_nofont">{props.data.info}</p>
                </div>

            </div>

            </div>
        </PopUp>

        

        </div>
    )



}

export default PortfolioBlock;